import type { ForgotPasswordConfig } from '#types/config/components/dialog/forgotPassword'

export default {
  brandClasses: {
    backButton: 'mb-4 flex items-center'
  }
} satisfies ForgotPasswordConfig
